import styled from 'styled-components';

export const Container = styled.div`
    h4 {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
    font-family: source-sans-pro, sans-serif;
`;

export const SubTitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
`;
